const Budou = () => {
  return <div className="budou"></div>;
};

export default Budou;
